module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-29-497a6e9be4f493ecdd287b51377079a0.png";